import { Pressable, Text, View } from "react-native";

interface StarRatingPickerProps {
  value: number;
  onChange: (rating: number) => void;
  size?: "sm" | "md";
}

function StarRatingPicker({
  value,
  onChange,
  size = "md",
}: StarRatingPickerProps) {
  const starSize = size === "sm" ? "text-xl" : "text-3xl";

  return (
    <View className="flex-row items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Pressable
          key={star}
          onPress={() => onChange(star)}
          className="active:opacity-70"
        >
          <Text
            className={`${starSize} ${star <= value ? "text-amber-500" : "text-gray-300"}`}
          >
            ★
          </Text>
        </Pressable>
      ))}
    </View>
  );
}

export default StarRatingPicker;
